<div class="doctor-notes-container">
  <div class="page-title__bar">
    <div>
      <h4 class="title">Generate Doctor Notes</h4>
    </div>
  </div>

  <div style="display: flex; height: calc(100vh - 120px); overflow: hidden">
    <div class="half-width">
      <div class="modal-body">
        <h5>Transcription</h5>
        <div class="transcription-section">
          <textarea
            [(ngModel)]="transcription"
            placeholder="Enter transcription text here..."
            rows="20"
            class="transcription-textarea"
          ></textarea>
        </div>

        <h5>Prompt <small>(Optional)</small></h5>
        <div class="prompt-section">
          <textarea
            [(ngModel)]="prompt"
            placeholder="Enter additional prompt instructions here..."
            rows="8"
            class="prompt-textarea"
          ></textarea>
          <small class="form-text text-muted">
            <i class="fas fa-info-circle"></i>
            Prompt should include "${{ "{" }}transcription{{ "}" }}" variable
            for the AI model to work properly.
          </small>

          <div class="button-container">
            <div class="prompt-controls">
              <select
                id="promptSelect"
                class="form-control prompt-dropdown"
                [(ngModel)]="selectedPromptId"
                (ngModelChange)="onPromptDropdownChange($event)"
              >
                <option value="">Version</option>
                <option
                  *ngFor="let prompt of prompts; let i = index"
                  [value]="prompt.id"
                  [class.active-prompt]="prompt.is_active"
                >
                  {{ prompt.is_active ? "★ " : "" }}v{{ getVersionNumber(i) }}
                </option>
              </select>
              <button
                class="btn btn-primary publish-btn"
                (click)="publishPrompt()"
                [disabled]="isPublishing || !prompt?.trim()"
              >
                <span *ngIf="!isPublishing">Publish</span>
                <span *ngIf="isPublishing">Publishing...</span>
              </button>
            </div>
            <button
              class="btn btn-primary generate-btn"
              (click)="generateDoctorNotes()"
              [disabled]="isLoading"
            >
              <span *ngIf="!isLoading">Generate Doctor Notes</span>
              <span *ngIf="isLoading">Generating...</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="vr"></div>

    <div class="half-width">
      <div class="modal-body">
        <div *ngIf="isLoading" class="loading-message">
          <h5>Doctor Notes Loading Please Wait...</h5>
        </div>
        <div
          *ngIf="!isLoading && !parsedData && !doctorNotes"
          class="no-content"
        >
          <h5>Generated doctor notes will appear here</h5>
        </div>

        <div *ngIf="parsedData">
          <h5>
            <button class="copy-btn" (click)="copySection('doctorNotes')">
              <i class="fas fa-thumbtack"></i>
            </button>
            Doctor Notes
          </h5>
          <div *ngIf="parsedData?.doctor_notes" #doctorNotes>
            <ng-container
              *ngIf="
                !(
                  parsedData.doctor_notes['History Of Present Illness'] &&
                  parsedData.doctor_notes['History Of Present Illness'].History
                )
              "
            >
              <p><strong>History of Present Illness:</strong></p>
              <p>{{ parsedData.doctor_notes["History Of Present Illness"] }}</p>
            </ng-container>
            <ng-container
              *ngIf="
                parsedData.doctor_notes['History Of Present Illness'] &&
                parsedData.doctor_notes['History Of Present Illness'].History
              "
            >
              <p><strong>History of Present Illness:</strong></p>
              <p>
                {{
                  parsedData.doctor_notes["History Of Present Illness"].History
                }}
              </p>
              <p
                *ngIf="
                  parsedData.doctor_notes['History Of Present Illness']
                    .Location !== 'NONE' &&
                  parsedData.doctor_notes['History Of Present Illness']
                    .Location !== 'N/A' &&
                  parsedData.doctor_notes['History Of Present Illness']
                    .Location !== 'None'
                "
              >
                {{
                  parsedData.doctor_notes["History Of Present Illness"].Location
                }}
              </p>
              <p
                *ngIf="
                  parsedData.doctor_notes['History Of Present Illness']
                    .Quality !== 'NONE' &&
                  parsedData.doctor_notes['History Of Present Illness']
                    .Quality !== 'N/A' &&
                  parsedData.doctor_notes['History Of Present Illness']
                    .Quality !== 'None'
                "
              >
                {{
                  parsedData.doctor_notes["History Of Present Illness"].Quality
                }}
              </p>
              <p
                *ngIf="
                  parsedData.doctor_notes['History Of Present Illness']
                    .Severity !== 'NONE' &&
                  parsedData.doctor_notes['History Of Present Illness']
                    .Severity !== 'N/A' &&
                  parsedData.doctor_notes['History Of Present Illness']
                    .Severity !== 'None'
                "
              >
                {{
                  parsedData.doctor_notes["History Of Present Illness"].Severity
                }}
              </p>
              <p
                *ngIf="
                  parsedData.doctor_notes['History Of Present Illness']
                    .Duration !== 'NONE' &&
                  parsedData.doctor_notes['History Of Present Illness']
                    .Duration !== 'N/A' &&
                  parsedData.doctor_notes['History Of Present Illness']
                    .Duration !== 'None'
                "
              >
                {{
                  parsedData.doctor_notes["History Of Present Illness"].Duration
                }}
              </p>
              <p
                *ngIf="
                  parsedData.doctor_notes['History Of Present Illness']
                    .Context !== 'NONE' &&
                  parsedData.doctor_notes['History Of Present Illness']
                    .Context !== 'N/A' &&
                  parsedData.doctor_notes['History Of Present Illness']
                    .Context !== 'None'
                "
              >
                {{
                  parsedData.doctor_notes["History Of Present Illness"].Context
                }}
              </p>
              <p
                *ngIf="
                  parsedData.doctor_notes['History Of Present Illness']
                    .Timing !== 'NONE' &&
                  parsedData.doctor_notes['History Of Present Illness']
                    .Timing !== 'N/A' &&
                  parsedData.doctor_notes['History Of Present Illness']
                    .Timing !== 'None'
                "
              >
                {{
                  parsedData.doctor_notes["History Of Present Illness"].Timing
                }}
              </p>
              <p
                *ngIf="
                  parsedData.doctor_notes['History Of Present Illness'][
                    'Associated Signs and Symptoms'
                  ] !== 'NONE' &&
                  parsedData.doctor_notes['History Of Present Illness'][
                    'Associated Signs and Symptoms'
                  ] !== 'N/A' &&
                  parsedData.doctor_notes['History Of Present Illness'][
                    'Associated Signs and Symptoms'
                  ] !== 'None'
                "
              >
                {{
                  parsedData.doctor_notes["History Of Present Illness"][
                    "Associated Signs and Symptoms"
                  ]
                }}
              </p>
              <p
                *ngIf="
                  parsedData.doctor_notes['History Of Present Illness'][
                    'Modifying Factors'
                  ] !== 'NONE' &&
                  parsedData.doctor_notes['History Of Present Illness'][
                    'Modifying Factors'
                  ] !== 'N/A' &&
                  parsedData.doctor_notes['History Of Present Illness'][
                    'Modifying Factors'
                  ] !== 'None'
                "
              >
                {{
                  parsedData.doctor_notes["History Of Present Illness"][
                    "Modifying Factors"
                  ]
                }}
              </p>
            </ng-container>

            <p *ngIf="parsedData?.doctor_notes?.['Physical Examination']">
              <strong>Physical Examination:</strong>
            </p>
            <p>{{ parsedData.doctor_notes["Physical Examination"] }}</p>

            <p *ngIf="parsedData?.doctor_notes?.['Diagnostics']">
              <strong>Diagnostics:</strong>
            </p>
            <p>{{ parsedData.doctor_notes["Diagnostics"] }}</p>

            <p *ngIf="parsedData?.doctor_notes?.['Assessment/Plan']">
              <strong>Assessment/Plan:</strong>
            </p>
            <p>{{ parsedData.doctor_notes["Assessment/Plan"] }}</p>
          </div>

          <h5 *ngIf="parsedData?.Order?.length || parsedData?.recommendations">
            <button class="copy-btn" (click)="copySection('orders')">
              <i class="fas fa-thumbtack"></i>
            </button>
            Orders
          </h5>
          <p *ngIf="!parsedData?.Order?.length">NONE</p>
          <ul *ngIf="parsedData?.Order?.length" #orders>
            <li *ngFor="let order of parsedData.Order">
              <strong>Type:</strong> {{ order.type }} <br />
              <strong>Order:</strong> {{ order.order }} <br />
              <strong>Description:</strong> {{ order.description }}
            </li>
          </ul>

          <h5 *ngIf="parsedData?.recommendations">
            <button class="copy-btn" (click)="copySection('recommendations')">
              <i class="fas fa-thumbtack"></i>
            </button>
            Recommendations
          </h5>
          <div *ngIf="parsedData?.recommendations" #recommendations>
            <p *ngIf="parsedData?.recommendations?.tests?.length">
              <strong>Tests:</strong>
            </p>
            <ul>
              <li *ngFor="let test of parsedData.recommendations.tests">
                <span *ngIf="test.related_to" style="font-weight: 400">{{
                  test.related_to
                }}</span
                ><br />
                <p>{{ test.name }} - {{ test.reason }}</p>
              </li>
            </ul>

            <p *ngIf="parsedData?.recommendations?.medications?.length">
              <strong>Medications:</strong>
            </p>
            <ul>
              <li *ngFor="let med of parsedData.recommendations.medications">
                <span *ngIf="med.related_to" style="font-weight: 400">{{
                  med.related_to
                }}</span
                ><br />
                {{ med.name }} - {{ med.dosage }} ({{ med.purpose }})
              </li>
            </ul>

            <p *ngIf="parsedData?.recommendations?.treatments?.length">
              <strong>Treatments:</strong>
            </p>
            <ul>
              <li
                *ngFor="let treatment of parsedData.recommendations.treatments"
              >
                <span *ngIf="treatment.related_to" style="font-weight: 400">{{
                  treatment.related_to
                }}</span
                ><br />
                {{ treatment.name }} - {{ treatment.description }}
              </li>
            </ul>

            <p *ngIf="parsedData?.recommendations?.risk_factors?.length">
              <strong>Risk Factors:</strong>
            </p>
            <ul>
              <li
                *ngFor="
                  let treatment of parsedData.recommendations.risk_factors
                "
              >
                <span *ngIf="treatment.related_to" style="font-weight: 400">{{
                  treatment.related_to
                }}</span
                ><br />
                Factor : {{ treatment.factor }}
              </li>
            </ul>

            <p *ngIf="parsedData?.recommendations?.considerations?.length">
              <strong>Considerations:</strong>
            </p>
            <p>{{ parsedData.recommendations.considerations }}</p>
          </div>
        </div>

        <div *ngIf="!parsedData && doctorNotes" class="raw-notes">
          <h5>
            <button class="copy-btn" (click)="copyRawNotes()">
              <i class="fas fa-thumbtack"></i>
            </button>
            Doctor Notes
          </h5>
          <pre>{{ doctorNotes }}</pre>
        </div>
      </div>
    </div>
  </div>
</div>
